import { z, isoZ } from 'my-zod'
import { DamageWaiverCaseInvolvementTypeEnum } from '../damage-waiver-case-enums'

export const involvedPartyModel = z.object({
  id: z.string().uuid(),
  damageWaiverCaseShortId: z.string(),
  name: z.string().max(100).nonempty(),
  involvement: DamageWaiverCaseInvolvementTypeEnum,
  phone: z.string().max(40).nullable().setLabel('Phone Number'),
  injured: z.boolean().setLabel('Were they injured ?'),
  medicalTreatmentProvided: z.boolean().setLabel('Was medical treatment provided ?'),
  injuryDescription: z.string().max(100),
  incidentStatement: z.string(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant()
})

export type involvedPartyModel = z.infer<typeof involvedPartyModel>
